import { createContext, useContext } from 'react';

type ContentTitleVisibilityContextValue = {
  setHideContentTitle: (hide: boolean) => void;
  setHideContentTitleOnDesktop: (hide: boolean) => void;
};

export const ContentTitleVisibilityContext =
  createContext<ContentTitleVisibilityContextValue | null>(null);

export const useContentTitleVisibility = () =>
  useContext(ContentTitleVisibilityContext);
